import React from 'react'
import cx from 'classnames'
import { Field } from 'redux-form'
import { Input, Popup } from 'semantic-ui-react'

import { ComponentContainer } from 'shared/StyledComponents'

import translate from './translate'
import { getValidationClasses } from 'loankeeper-common/helpers'
import { getSymbolsCountProps } from '../helpers'

const numberNormalizer = (dontParseToInt) => (value, prevValue) => {
  if (value) {
    if (!/^[0-9]+$/.test(value)) return prevValue

    return dontParseToInt ? value : parseInt(value, 10)
  }

  return ''
}

class NumberField extends React.PureComponent {
  state = {
    errorOpen: false,
    error: '',
  }

  handleKeyPress = (event) => {
    const { currentTarget, key } = event

    if (key !== 'Enter') {
      if ((currentTarget.value && Number.isNaN(parseFloat(currentTarget.value))) || Number.isNaN(parseFloat(key))) {
        this.setState({
          errorOpen: true,
          error: translate('HINT_ERR_NUMBER_ONLY'),
        })
      } else if (this.state.error) {
        this.setState({
          errorOpen: false,
          error: '',
        })
      }
    }
  }

  isValueValid = (value) =>
    !value || (!isNaN(value) && this.props.unsetMaxLength ? true : value.replace('.', '').replace('-', '').length < 17)

  handleInputChange = (_, { value }) => {
    if (this.isValueValid(value)) {
      this.props.input.onChange(value)
    }
  }

  handleInputBlur = (event) => {
    this.setState({ errorOpen: false, error: '' })

    this.props.input.onBlur(event)
  }

  handlePreventAction = (event) => {
    event.preventDefault()
  }

  render() {
    const { meta, input, className, required, maxLength, GetError, flags = {}, max, min, ...rest } = this.props
    const open = (meta.active && meta.error && meta.touched) || this.state.errorOpen
    const error = this.state.error || meta.error
    const popupClasses = cx(className, 'LKError', {
      'LKError--hidden': !open || error === 'invalid',
    })

    const inputClasses = getValidationClasses(meta.error, required, meta.touched)

    return (
      <Popup
        className={popupClasses}
        style={{ minWidth: 100 }}
        on="focus"
        popperDependencies={[error, open]}
        popperModifiers={{ preventOverflow: { enabled: false } }}
        trigger={
          <ComponentContainer input>
            <Input
              {...rest}
              {...input}
              {...getSymbolsCountProps(flags.symbolCounter, input.value.toString())}
              type="text"
              fieldtype="number"
              fluid
              onKeyPress={this.handleKeyPress}
              onBlur={this.handleInputBlur}
              className={inputClasses}
              onChange={this.handleInputChange}
              max={max}
              min={min}
              maxLength={maxLength}
              onDrag={this.handlePreventAction}
              onDrop={this.handlePreventAction}
            />
          </ComponentContainer>
        }
      >
        {GetError && <GetError error={error} />}
      </Popup>
    )
  }
}

const DecoratedField = ({ dontParseToInt, ...rest }) => (
  <Field {...rest} component={NumberField} normalize={numberNormalizer(dontParseToInt)} />
)

export default DecoratedField
